import React from 'react';
import Container from './styled';
import LegendTag from './LegendTag';
import LegendDescription from './LegendDescription';

interface ModalityProps {
  name: string;
  descriptions: string[];
  color: string;
}

interface LegendItemProps {
  modality: ModalityProps;
}

const LegendItem = ({ modality }: LegendItemProps) => {
  const { name, descriptions, color } = modality;
  return (
    <Container>
      <LegendTag name={name} color={color} />
      <LegendDescription descriptions={descriptions} />
    </Container>
  );
};

export default LegendItem;
